/**
 * Created by oe on 28/11/14.
 */

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { PeriodFilterWidget as mainModule } from './main';
import * as $ from 'jquery';
import * as Config from './config';
import { init as mainTheme } from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-filter-period.sass');

export class PeriodFilterWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;
    public static priority: number = Config.priority;

    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-filter-period'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId; //VR: WI80078
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(PeriodFilterWidget);
